import { ref, reactive } from "vue";
import { defineStore } from "pinia";
import networkController from "@/js/networkController.js";
import apiEndpoints from "@/assets/json/apiEndpoints.json";

export const useUsersStore = defineStore('usersStore', () => {
  const USER_TOKEN = ref(null)
  const USER_INFO = ref(null)
  const OWNER_INFO = ref(null)
  const OWNER_HISTORY = ref(null)
  const isOwnerInviteListFetched = ref(false)
  const isOwnerInviteShowed = ref(false)
  const ownerInviteListLength = ref(0)

  function setUserToken(token = null, update_cookie = false, set_max_age = false) {
    const max_age_seconds = (set_max_age) ? 31 * 24 * 60 * 60 : 24 * 60 * 60

    if (update_cookie) {
      document.cookie = `access_token=${token}; path=/; max-age=${max_age_seconds};`
    }

    USER_TOKEN.value = token
  }

  function clearStore () {
    USER_TOKEN.value = null
    USER_INFO.value = null
  }

  async function postSendCredentials(data) {
    return await networkController.post(apiEndpoints.postSendCredentials, data)
      .then((response) => {
        console.log('response',response)
        console.log('response?.data',response?.data)
        return response?.data;
      })
      .catch((error) => {
        console.log('error',error)
        return { error_code: 500, error_message: 'Server error'}
      })
  }

  async function postSendCode(data) {
    return await networkController.post(apiEndpoints.postSendCode, data)
      .then((response) => {
        return response?.data;
      })
  }

  async function postFetchUserInfo(token) {
    return await networkController.post(
      apiEndpoints.postFetchUserInfo,
      {},
      {
        headers: {
          Authorization: `Bearer ${token || USER_TOKEN.value}`
        }
      }
    ).then((result) => {
      return result?.data
    })
  }

  async function getFetchOwnerUserInfo() {
    return await networkController.get(
      apiEndpoints.getFetchOwnerUserInfo,
      {
        headers: {
          Authorization: `Bearer ${USER_TOKEN.value}`
        }
      }
    ).then((result) => {
      return result?.data
    })
  }

  async function getFetchOwnerUserHistory() {
    return await networkController.get(
      apiEndpoints.getFetchOwnerUserHistory,
      {
        headers: {
          Authorization: `Bearer ${USER_TOKEN.value}`
        }
      }
    ).then((result) => {
      return result?.data
    })
  }

  async function postFetchOwnerUserHistory(data = {}) {
    return await networkController.post(
      `${apiEndpoints.getFetchOwnerUserHistory}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${USER_TOKEN.value}`
        }
      },
    ).then((result) => {
      return result?.data
    })
  }

  async function postEditTSMUser(data, tp_code) {
    return await networkController.post(apiEndpoints.userEdit + `/${tp_code}`, data)
        .then((response) => {
          return response?.data;
        })
        .catch((error) => {
          return { error_code: 500, error_message: 'Server error'}
        })
  }

  async function postDeleteTSMUser(data) {
    return await networkController.post(apiEndpoints.userDelete, data)
        .then((response) => {
          return response?.data;
        })
        .catch((error) => {
          return { error_code: 500, error_message: 'Server error'}
        })
  }
  
  async function importTransactions(data: FormData) {
    return await networkController.post(
      apiEndpoints.importTransactions,
      data,
      {
        headers: {
          Authorization: `Bearer ${USER_TOKEN.value}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then((result) => result?.data)
    .catch((error) => {
      const serverData = error?.response?.data;
      if (serverData && (serverData.error_code || serverData.error_message)) {
        return serverData;
      }
      const status = error?.response?.status || 500;
      return { error_code: status, error_message: serverData?.error_message || 'Server error' };
    })
  }

  async function downloadTransactionsPattern() {
    return await networkController.get(apiEndpoints.downloadTransactionsPattern, {
      responseType: 'blob'
    })
    .then((result) => {
      return result?.data;
    })
    .catch((error) => {
      console.error("Ошибка скачивания файла:", error);
      return { error_code: 500, error_message: 'Server error' };
    });
  }

  async function inviteSellerRequestsList(data) {
    return await networkController.post(apiEndpoints.connection_requests.root, data)
      .then((response) => {
        return response?.data;
      })
  }

  async function inviteSeller(data) {
    return await networkController.post(apiEndpoints.connection_requests.create, data)
      .then((response) => {
        return response?.data;
      })
  }

  async function inviteFromSeller(data) {
    return await networkController.post(apiEndpoints.connection_requests.from_seller, data)
      .then((response) => {
        return response?.data;
      })
  }

  async function inviteRequestsList() {
    return await networkController.get(apiEndpoints.connection_requests.for_owner)
      .then((response) => {
        if(response?.data?.error_code === 0){
          console.log('response?.data',response?.data)
          isOwnerInviteListFetched.value = true
          if(ownerInviteListLength.value !== response?.data?.data?.length){
            isOwnerInviteListFetched.value = false
            isOwnerInviteShowed.value = false
          }
          ownerInviteListLength.value = response?.data?.data?.length || 0

          console.log('ownerInviteListLength.value',ownerInviteListLength.value)
        }
        return response?.data;
      })
  }

  async function inviteMakeDicision(data) {
    return await networkController.post(apiEndpoints.connection_requests.make_decision, data)
      .then((response) => {
        return response?.data;
      })
  }

  async function inviteMakeCancel(data) {
    return await networkController.post(apiEndpoints.connection_requests.cancel, data)
      .then((response) => {
        return response?.data;
      })
  }

  async function enterAgreementsChecked(data) {
    return await networkController.post(apiEndpoints.enterAgreementsChecked, data)
      .then((response) => {
        return response?.data;
      })
  }
  

  async function performCoinOperation(data: FormData) {
    // TODO: Implement API endpoint in apiEndpoints.json
    // return await networkController.post(
    //   apiEndpoints.postPerformCoinOperation,
    //   data,
    //   {
    //     headers: {
    //       Authorization: `Bearer ${USER_TOKEN.value}`,
    //       'Content-Type': 'multipart/form-data'
    //     }
    //   }
    // ).then((result) => result?.data)
  }

  return {
    USER_TOKEN,
    USER_INFO,
    OWNER_INFO,
    OWNER_HISTORY,
    isOwnerInviteListFetched,
    isOwnerInviteShowed,
    ownerInviteListLength,
    setUserToken,
    clearStore,
    postSendCredentials,
    postSendCode,
    postFetchUserInfo,
    getFetchOwnerUserInfo,
    getFetchOwnerUserHistory,
    postFetchOwnerUserHistory,
    postEditTSMUser,
    postDeleteTSMUser,
    importTransactions,
    downloadTransactionsPattern,
    performCoinOperation,
    inviteSellerRequestsList,
    inviteSeller,
    inviteFromSeller,
    inviteRequestsList,
    inviteMakeDicision,
    inviteMakeCancel,
    enterAgreementsChecked
  }
})
